<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Нормативы пользования') }}</h1>
    <div class="my-organization">
      <div class="bgw-pdg-20">
        <v-form
          ref="form"
          lazy-validation
          @submit.prevent="editUsageStandard"
          class="v-form"
        >
          <h4 class="title-m">{{ faunaLimit.faunaName }}</h4>
          <div class="form-group">
            <div class="quota-fields justify-center">
              <div
                class="quota-field field-input-xs"
                :class="{ invalid: $v.faunaLimit.limiting.$error || !$v.faunaLimit.limiting.between }"
              >
                <label>{{ $t('Норматив пользования') }}:</label>
                <v-text-field
                  v-model="faunaLimit.limiting"
                  type="number"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
                <span class="percentage">%</span>
              </div>
            </div>
            <p
              v-if="!$v.faunaLimit.limiting.between"
              class="text-helper text-center"
              :class="{ invalid: !$v.faunaLimit.limiting.between }"
            >
              <small v-if="faunaLimit.limiting < $v.faunaLimit.limiting.$params.between.min">
                {{ $t('Норматив пользования не может быть меньше') }}
                <strong>{{ $v.faunaLimit.limiting.$params.between.min }}</strong>
              </small>
              <small v-if="faunaLimit.limiting > $v.faunaLimit.limiting.$params.between.max">
                {{ $t('Норматив пользования не может быть больше') }}
                <strong>{{ $v.faunaLimit.limiting.$params.between.max }}</strong>
              </small>
            </p>
          </div>
          <div class="form-bottom">
            <div class="form-action">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="onCancel"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import faunaLimit from '@/model/faunaLimit'
import { required, between } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    breadcrumbs: [],
    faunaLimit: {},
    rules: {
      faunaLimit: {
        limiting: {
          required,
          between: between(0, 40)
        }
      }
    }
  }),
  validations () {
    return this.rules
  },
  created () {
    this.getUsageStandardInfo()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    getUsageStandardInfo () {
      this.setLoading(true)
      faunaLimit.getInfo(this.$route.params.id)
        .then((res) => {
          this.faunaLimit = res.data.faunaLimit
          this.generateBreadcrumbs()
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
    },
    // Сохранение
    editUsageStandard () {
      if (!this.validateForm()) {
        return
      }

      this.setLoading(true)
      faunaLimit.edit(this.$route.params.id, this.faunaLimit)
        .then((res) => {
          this.$router.push({
            name: 'quota-usage-standard'
          })
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Нормативы пользования'),
          disabled: false,
          href: '/quota-usage-standard'
        },
        {
          text: this.faunaLimit.faunaName,
          disabled: true
        }
      ]
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'quota-usage-standard'
      })
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
